/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Operations_Val_CustomerInputs */

const en_wb_operations_val_customer = /** @type {(inputs: Wb_Operations_Val_CustomerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`North Studio`)
};

const lv_wb_operations_val_customer = /** @type {(inputs: Wb_Operations_Val_CustomerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`North Studio`)
};

/**
* | output |
* | --- |
* | "North Studio" |
*
* @param {Wb_Operations_Val_CustomerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_operations_val_customer = /** @type {((inputs?: Wb_Operations_Val_CustomerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Operations_Val_CustomerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_operations_val_customer(inputs)
	return en_wb_operations_val_customer(inputs)
});